<template>
  <v-app>
    <v-container fluid fill-height>
      <v-layout row wrap align-center justify-center>

        <!-- Title = Money Lending -->  
        <v-flex xs12 sm4 md4>
          <v-flex>
            <v-card-actions style="margin-bottom: -20px;">  
              <v-spacer></v-spacer>
                <v-avatar
                  color="grey lighten-4"
                >
                <img style="height: 10%; width: 220px;" src="@/assets/horizontalLogo.png" alt="avatar">
              </v-avatar>
              <v-spacer></v-spacer>
            </v-card-actions>
            
            <v-card-actions style="margin-top: -20px;">
              <v-spacer></v-spacer>  
                <h3 class="primary--text font-weight-light text-muted"> All in One Business Platform</h3>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-flex>  
        
        <v-card>  
          <v-card-title primary-title class="primary white--text headline">
            Forgot password
          </v-card-title>
          <v-card-text>
          <form>
            <span>Please enter your email to reset password.</span>
            <v-text-field
              prepend-icon="person"
              name="email"
              label="Email"
              id="email"
              type="email"
              v-model="email"
              :rules="emailRules"
              required>
            </v-text-field>
             <template v-if="resetSuccess"><span class="green--text">Password Reset link has been sent to {{email}} Please check your inbox.</span></template>
          </form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn round primary-title class="primary white--text"  @click="sendVerificationLink">
            Send Verification link 
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
        <v-card-actions> 
          <v-spacer></v-spacer> 
          <v-btn round href="/login" class="grey white--text" type="submit">Go To Login</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>  
    </v-flex>
  </v-layout>
  </v-container>
  <v-snackbar :timeout="timeout" top v-model="snackbar">
    {{message}}
  </v-snackbar>
  </v-app>
</template>
<script>
import { cfirebase } from '../../services/firebase.js'
import { createNamespacedHelpers } from 'vuex'

// const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']
const mapGlobalActions = createNamespacedHelpers('Global')['mapActions']

export default {
  data () {
    return {
      message: null,
      resetSuccess : false,
      snackbar: false,
      timeout: 5000,
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
    }
  },
  created () {
    this.$bindAsArray(
      'operators',
      this.$root.$firebaseRefs.operator
    )
    this.$bindAsObject(
      'brands',
      this.$root.$firebaseRefs.brand
    )
  },
  methods: {
    ...mapGlobalActions('SET_SELECTED_BRAND', 'SET_BRANDS'),
    isVerified () {
      if (!this.email) {
        this.message = 'Wrong Input'
        return false
      }
      return true
    },
    sendVerificationLink () {
      if (!this.isVerified()) {
        this.snackbar = true
        return
      }
    cfirebase.auth().sendPasswordResetEmail(this.email).then(()=> {
      this.resetSuccess = true
      // Email sent.
    }).catch(function(error) {
        console.log("err")
        console.log(error)
        // An error happened.
      });
    },
  }
}
</script>




// WEBPACK FOOTER //
// src/components/ForgotPassword/index.vue